import { useMemo } from 'react';
import { ISegmentResults } from '../services/reports';
import { THEME as theme } from '../styles/theme';

type TChartColors = Record<string, string[]>;

interface IChartData {
  name: string;
  value: number;
}

interface IChart {
  data: IChartData[];
  colors: string[];
}

export interface IPRMResults extends ISegmentResults {
  chart: IChart;
}

const colors: TChartColors = {
  S1: [
    theme.colors.accent.green[100],
    theme.colors.accent.blue[30],
    theme.colors.accent.orange[30],
    theme.colors.accent.violet[30],
    theme.colors.accent.red[30],
  ],
  S2: [
    theme.colors.accent.green[30],
    theme.colors.accent.blue[100],
    theme.colors.accent.orange[30],
    theme.colors.accent.violet[30],
    theme.colors.accent.red[30],
  ],
  S3: [
    theme.colors.accent.green[30],
    theme.colors.accent.blue[30],
    theme.colors.accent.orange[100],
    theme.colors.accent.violet[30],
    theme.colors.accent.red[30],
  ],
  S4: [
    theme.colors.accent.green[30],
    theme.colors.accent.blue[30],
    theme.colors.accent.orange[30],
    theme.colors.accent.violet[100],
    theme.colors.accent.red[30],
  ],
  S5: [
    theme.colors.accent.green[30],
    theme.colors.accent.blue[30],
    theme.colors.accent.orange[30],
    theme.colors.accent.violet[30],
    theme.colors.accent.red[100],
  ],
};

const usePerformanceRiskMonitor = (results: ISegmentResults[]) => {
  const chart = useMemo<IChartData[]>(
    () =>
      results.map(({ segment, share }) => ({
        name: `${segment.code}`,
        value: share.current,
      })),
    [results]
  );

  const prmTransformedData = useMemo<IPRMResults[]>(
    () =>
      results.map(({ count, rating, segment, share, workEnvironment }) => ({
        chart: { data: chart, colors: colors[segment.code] },
        count,
        rating,
        segment,
        share,
        workEnvironment,
      })),
    [chart, results]
  );

  return { prmTransformedData };
};

export default usePerformanceRiskMonitor;
